import { ReactNode } from "react";
import { Box, Flex, Text } from "@mantine/core";
import { MapLayerPickerCard } from "./MapLayerPickerCard";
import classes from "./MapLayerPickerPart.module.css";

type MapLayerPickerPartProps = {
  title: string;
  children: ReactNode;
};

export const MapLayerPickerPart = ({
  title,
  children,
}: MapLayerPickerPartProps) => (
  <Box mb="md">
    <Text mb="xs" className={classes.title}>
      {title}
    </Text>
    {children}
  </Box>
);

export const Grid = ({ children }: { children: ReactNode }) => (
  <Flex
    mih={50}
    maw={900}
    gap="xs"
    justify="flex-start"
    align="flex-start"
    direction="row"
    wrap="wrap"
  >
    {children}
  </Flex>
);

MapLayerPickerPart.Card = MapLayerPickerCard;
MapLayerPickerPart.Grid = Grid;
